@for (item of customerService.DropdownMenu(); track $index) {
    <a is="navigate-link" [routerLink]="item?.link" [attr.target]="item?.target ?? null" >{{ item?.title }}</a>
}
@if (customerService.Current()?.isSupervisor) {
    <a is="navigate-link" [routerLink]="['/', catalog, 'dashboard']">{{ 'CUSTOMER.DASHBOARD_LINK' | translate }}</a>
}
<button type="button" (click)="customerService.logout()">{{ 'CUSTOMER.LOGOUT' | translate }}</button>
